export function checkValidationDigit(identifier, validationDigit) {
    const number = identifier
        .split('')
        .reverse()
        .map((item, i) => ((i % 8) + 2) * parseInt(item, 10))
        .reduce((x, y) => x + y, 0);
    let result = number % 11;
    if (result < 2) {
        result = 0;
    }
    else {
        result = 11 - result;
    }
    return result.toString() === validationDigit;
}
export function isValidMaskedCnpj(value) {
    return value.length === 14 && value.includes('*');
}
export function isValidCnpj(value) {
    if (!value)
        return false;
    if (isValidMaskedCnpj(value)) {
        return true;
    }
    const identifier = value.replace(/\D/g, '');
    if (identifier.toString().length === 14) {
        const number = identifier.toString().slice(0, -2);
        const firstValidationDigit = identifier.toString()[12];
        const secondValidationDigit = identifier.toString()[13];
        if (checkValidationDigit(number, firstValidationDigit) &&
            checkValidationDigit(number + firstValidationDigit, secondValidationDigit)) {
            return true;
        }
        return false;
    }
    return false;
}
